import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OccEndpointsService } from '@spartacus/core';


@Injectable({
  providedIn: 'root'
})
export class UnifyRedirectService {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) { }

  authenticateUser(token){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const url = this.occEndpoints.buildUrl(`authenticate/byToken?token=${token}`);
    return this.http.post<any>(
      url,
      null,
      httpOptions
    );
    }  
}
